import { useState } from "react";
import { Check } from "lucide-react";
import { api } from "@/lib/api";
import { cn } from "@/lib/utils";

// Keep keys in step with HEARD_FROM in backend/server.py.
const OPTIONS = [
  ["friend_family", "Friend or family"],
  ["whatsapp", "WhatsApp"],
  ["instagram", "Instagram"],
  ["google", "Google search"],
  ["youtube", "YouTube"],
  ["facebook", "Facebook"],
  ["ai_assistant", "ChatGPT or another AI"],
  ["event_shop", "A shop, stall or event"],
  ["gift", "Got it as a gift"],
  ["other", "Other"],
];

/** One optional tap after purchase. Word of mouth is invisible to analytics, so we ask. */
export default function HeardFrom({ orderId, email, initial }) {
  const [picked, setPicked] = useState(initial || "");
  const [busy, setBusy] = useState(false);
  const pick = async (key) => {
    if (picked || busy) return;
    setBusy(true);
    try {
      await api.post(`/orders/${orderId}/heard-from`, { answer: key, email: email || undefined });
      setPicked(key);
    } catch { /* optional question: fail quietly */ }
    finally { setBusy(false); }
  };
  return (
    <div className="mt-10 rounded-2xl border border-brand-gold/20 bg-white p-6 text-center" data-testid="heard-from">
      {picked ? (
        <p className="font-body text-[15px] text-brand-ink inline-flex items-center gap-2"><Check className="w-4 h-4 text-brand-gold" /> Thank you. That helps a small family business more than you know.</p>
      ) : (
        <>
          <p className="font-display text-lg text-brand-obsidian">One quick question: how did you hear about Karijeeva?</p>
          <p className="font-body text-xs text-ink-muted mt-1">Optional. One tap.</p>
          <div className="mt-4 flex flex-wrap justify-center gap-2">
            {OPTIONS.map(([k, label]) => (
              <button key={k} type="button" disabled={busy} onClick={() => pick(k)}
                className={cn("rounded-control border border-black/10 px-4 py-2 font-body text-[14px] text-brand-ink hover:border-brand-gold hover:bg-brand-parchment-soft transition-colors disabled:opacity-60")}
                data-testid={`heard-${k}`}>{label}</button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
